import type { FaireProductEntity } from "../../entity_types/product";

export const p_2e3zesy45w: FaireProductEntity = {
  token: "p_2e3zesy45w",
  type: "product",
  name: "kites mini enclosure notecard",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/4efd3925c9da8bbf1e919046f8b3ce3bd5679e67016fc87d8fbac2c0ad2dfd75.jpeg",
  galleryImageUrls: [],
  priceDollars: 2,
  description:
    'A mini notecard for petite greetings. Perfect for adding to a gift or popping in a gift card for a pretty presentation. \n\n\nDetails:\n\n- single card + envelope \n- blank inside\n- 2.5" x 3.5"\n- Printed on 120lb superfine paper\n\n\n',
  tags: [],
  msrpDollars: 4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:14:51.211Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
